import React from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import { ResponsiveContainer } from "recharts";
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import DateRangeIcon from '@material-ui/icons/DateRange';
import moment from "moment";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import CardBox from '../../../../../components/CardBox';
import StanceBeamBarChart from '../../../../../components/Charts/StanceBeamBarChart';
import StanceBeamDoubleBarChart from '../../../../../components/Charts/StanceBeamDoubleBarChart';
import IntlMessages from "../../../../../util/IntlMessages";
import { Progress } from "reactstrap";
import DoughnutChart from "../../../../../components/Charts/DoughnutChart";
import Skeleton from '@material-ui/lab/Skeleton';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {
    getPlayerReport,
    getPlayerByTimeReport
} from '../../../../../actions/PlayerReportAction';

class Report extends React.Component {
    constructor() {
        super()
        this.state = {
            tabValue: 4,
            headerData: "LifeTime",
            totalSessions: 0,
            totalDuration: 0,
            totalSwings: 0,
            totalPlayed: 0,
            overallDefence: 0,
            overallAttack: 0,
            overallPowerful: 0,
            totalVerticleSwings: 0,
            avgEfficiencyVertical: 0,
            avgBatSpeedVertical: 0,
            avgImpactSpeedVertical: 0,
            avgDownswingAngleVertical: 0,
            avgFollowThruAngleVertical: 0,
            avgBackliftVertical: 0,
            avgBatfaceVertical: 0,
            avgBackliftDirectionVertical: 0,
            consistancyBackliftVertical: 0,
            consistancyBackliftDirectionalVertical: 0,
            consistancyBatfaceVertical: 0,
            totalHorizantalSwings: 0,
            avgEfficiencyHorizantal: 0,
            avgBatSpeedHorizantal: 0,
            avgImpactSpeedHorizantal: 0,
            avgDownswingAngleHorizantal: 0,
            avgFollowThruAngleHorizantal: 0,
            avgBackliftHorizantal: 0,
            avgBatfaceHorizantal: 0,
            avgBackliftDirectionHorizantal: 0,
            consistancyBackliftHorizantal: 0,
            consistancyBackliftDirectionalHorizantal: 0,
            consistancyBatfaceHorizantal: 0,
            speedData: [{
                x: "",
                "Max Bat Speed": "",
                "Bat Speed at Impact": ""
            }],
            backliftDirectionData: [{
                x: "",
                "Backlift Direction Angle": ""
            }],
            batFaceData: [{
                x: "",
                "Bat Face Angle": ""
            }],
            efficiencyData: [{
                x: "",
                "Efficiency": ""
            }],
            timeToImpactData: [{
                x: "",
                "Time to Impact": ""
            }],
            verticalBackliftData: [{
                x: "",
                "Backlift Angle": ""
            }],
            horizontalBackliftData: [{
                x: "",
                "Backlift Angle": ""
            }],
            verticalDownswingData: [{
                x: "",
                "Downswing Angle": ""
            }],
            horizontalDownswingData: [{
                x: "",
                "Downswing Angle": ""
            }],
            powerData: [{
                x: "",
                "Power": ""
            }]
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleEvent = this.handleEvent.bind(this)
        this.handleCallback = this.handleCallback.bind(this)
    }

    componentDidMount() {
        if (this.props.playerInView === null) {
            this.props.history.push('/app/players')
        } else {
            if (this.props.playerReportData === null || this.props.playerInView.uid !== this.props.playerUid) {
                const sessionToken = this.props.authUser.sessionToken;
                const playerUid = this.props.playerInView.uid;
                const payload = {
                    'sessionToken': sessionToken,
                    'playerUid': playerUid
                }
                this.props.getPlayerReport(payload);
            } else {
                if (this.props.playerReportData.hasOwnProperty("lifetime")) {
                    this.showReport("lifetime")
                }
            }
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.playerReportData !== null && this.props.playerReportData.hasOwnProperty("lifetime") && prevProps.playerReportLoader === true && this.props.playerReportLoader === false && this.props.playerReportError === null) {
            this.showReport("lifetime")
        }

        if (this.props.playerReportData !== null && this.props.playerReportData.hasOwnProperty("custom") && prevProps.playerReportByTimeLoader === true && this.props.playerReportByTimeLoader === false && this.props.playerReportByTimeError === null) {
            this.showReport("custom")
        }
    }
    showReport(condition) {
        var localSpeedData = []
        var localBackliftDirectionData = []
        var localBatFaceData = []
        var localEfficiencyData = []
        var localTimeToImpactData = []
        var localPowerData = []
        var localVerticalBackliftData = []
        var localHorizontalBackliftData = []
        var localVerticalDownswingData = []
        var localHorizontalDownswingData = []
        if (this.props.playerReportData[condition].playerProgressData.length > 0) {
            for (var i = 0; i < this.props.playerReportData[condition].playerProgressData.length; i++) {
                localSpeedData.push(
                    {
                        x: moment(this.props.playerReportData[condition].playerProgressData[i].completionDateTs).format('D-MMM-YY'), //    this.state.sessionData[i].startDate ? moment(this.state.sessionData[i].startDate.iso).format('D-MMM-YY') : moment(this.state.sessionData[i].createdAt).format('D-MMM-YY'),
                        "Max Bat Speed": Math.round(this.props.playerReportData[condition].playerProgressData[i].maxBatSpeed),
                        "Bat Speed at Impact": Math.round(this.props.playerReportData[condition].playerProgressData[i].speedAtImpact)
                    }
                )
                localBackliftDirectionData.push(
                    {
                        x: moment(this.props.playerReportData[condition].playerProgressData[i].completionDateTs).format('D-MMM-YY'),
                        "Backlift Direction Angle": Math.round(this.props.playerReportData[condition].playerProgressData[i].backliftDirection)
                    }
                )
                localBatFaceData.push(
                    {
                        x: moment(this.props.playerReportData[condition].playerProgressData[i].completionDateTs).format('D-MMM-YY'),
                        "Bat Face Angle": Math.round(this.props.playerReportData[condition].playerProgressData[i].batFaceAngle)
                    }
                )
                localEfficiencyData.push(
                    {
                        x: moment(this.props.playerReportData[condition].playerProgressData[i].completionDateTs).format('D-MMM-YY'),
                        "Efficiency": Math.round(this.props.playerReportData[condition].playerProgressData[i].efficiency)
                    }
                )
                localTimeToImpactData.push(
                    {
                        x: moment(this.props.playerReportData[condition].playerProgressData[i].completionDateTs).format('D-MMM-YY'),
                        "Time to Impact": Math.round(this.props.playerReportData[condition].playerProgressData[i].timeToImpact)
                    }
                )
                localPowerData.push(
                    {
                        x: moment(this.props.playerReportData[condition].playerProgressData[i].completionDateTs).format('D-MMM-YY'),
                        "Power": Math.round(this.props.playerReportData[condition].playerProgressData[i].power)
                    }
                )
                localVerticalBackliftData.push(
                    {
                        x: moment(this.props.playerReportData[condition].playerProgressData[i].completionDateTs).format('D-MMM-YY'),
                        "Backlift Angle": Math.round(this.props.playerReportData[condition].playerProgressData[i].backliftAngleVertical)
                    }
                )
                localHorizontalBackliftData.push(
                    {
                        x: moment(this.props.playerReportData[condition].playerProgressData[i].completionDateTs).format('D-MMM-YY'),
                        "Backlift Angle": Math.round(this.props.playerReportData[condition].playerProgressData[i].backliftAngleHorizontal)
                    }
                )
                localVerticalDownswingData.push(
                    {
                        x: moment(this.props.playerReportData[condition].playerProgressData[i].completionDateTs).format('D-MMM-YY'),
                        "Downswing Angle": Math.round(this.props.playerReportData[condition].playerProgressData[i].downswingAngleVertical)
                    }
                )
                localHorizontalDownswingData.push(
                    {
                        x: moment(this.props.playerReportData[condition].playerProgressData[i].completionDateTs).format('D-MMM-YY'),
                        "Downswing Angle": Math.round(this.props.playerReportData[condition].playerProgressData[i].downswingAngleHorizontal)
                    }
                )
            }
        } else {
            localSpeedData.push(
                {
                    x: "",
                    "Max Bat Speed": "",
                    "Bat Speed at Impact": ""
                }
            )
            localBackliftDirectionData.push(
                {
                    x: "",
                    "Backlift Direction Angle": ""
                }
            )
            localBatFaceData.push(
                {
                    x: "",
                    "Bat Face Angle": ""
                }
            )
            localEfficiencyData.push(
                {
                    x: "",
                    "Efficiency": ""
                }
            )
            localTimeToImpactData.push(
                {
                    x: "",
                    "Time to Impact": ""
                }
            )
            localPowerData.push(
                {
                    x: "",
                    "Power": ""
                }
            )
            localVerticalBackliftData.push(
                {
                    x: "",
                    "Backlift Angle": ""
                }
            )
            localHorizontalBackliftData.push(
                {
                    x: "",
                    "Backlift Angle": ""
                }
            )
            localVerticalDownswingData.push(
                {
                    x: "",
                    "Downswing Angle": ""
                }
            )
            localHorizontalDownswingData.push(
                {
                    x: "",
                    "Downswing Angle": ""
                }
            )
        }
        this.setState({
            totalSessions: Math.round(this.props.playerReportData[condition].totalSessions),
            totalDuration: Math.round(this.props.playerReportData[condition].totalDuration),
            totalSwings: Math.round(this.props.playerReportData[condition].totalSwings),
            totalPlayed: Math.round(this.props.playerReportData[condition].totalPlayed),
            overallDefence: Math.round(this.props.playerReportData[condition].overallDefence),
            overallAttack: Math.round(this.props.playerReportData[condition].overallAttack),
            overallPowerful: Math.round(this.props.playerReportData[condition].overallPowerful),
            totalVerticleSwings: Math.round(this.props.playerReportData[condition].totalVerticleSwings),
            avgEfficiencyVertical: Math.round(this.props.playerReportData[condition].avgEfficiencyVertical),
            avgBatSpeedVertical: Math.round(this.props.playerReportData[condition].avgBatSpeedVertical),
            avgImpactSpeedVertical: Math.round(this.props.playerReportData[condition].avgImpactSpeedVertical),
            avgDownswingAngleVertical: Math.round(this.props.playerReportData[condition].avgDownswingAngleVertical),
            avgFollowThruAngleVertical: Math.round(this.props.playerReportData[condition].avgFollowThruAngleVertical),
            avgBackliftVertical: Math.round(this.props.playerReportData[condition].avgBackliftVertical),
            avgBatfaceVertical: Math.round(this.props.playerReportData[condition].avgBatfaceVertical),
            avgBackliftDirectionVertical: Math.round(this.props.playerReportData[condition].avgBackliftDirectionVertical),
            consistancyBackliftVertical: Math.round(this.props.playerReportData[condition].consistancyBackliftVertical),
            consistancyBackliftDirectionalVertical: Math.round(this.props.playerReportData[condition].consistancyBackliftDirectionalVertical),
            consistancyBatfaceVertical: Math.round(this.props.playerReportData[condition].consistancyBatfaceVertical),
            totalHorizantalSwings: Math.round(this.props.playerReportData[condition].totalHorizantalSwings),
            avgEfficiencyHorizantal: Math.round(this.props.playerReportData[condition].avgEfficiencyHorizantal),
            avgBatSpeedHorizantal: Math.round(this.props.playerReportData[condition].avgBatSpeedHorizantal),
            avgImpactSpeedHorizantal: Math.round(this.props.playerReportData[condition].avgImpactSpeedHorizantal),
            avgDownswingAngleHorizantal: Math.round(this.props.playerReportData[condition].avgDownswingAngleHorizantal),
            avgFollowThruAngleHorizantal: Math.round(this.props.playerReportData[condition].avgFollowThruAngleHorizantal),
            avgBackliftHorizantal: Math.round(this.props.playerReportData[condition].avgBackliftHorizantal),
            avgBatfaceHorizantal: Math.round(this.props.playerReportData[condition].avgBatfaceHorizantal),
            avgBackliftDirectionHorizantal: Math.round(this.props.playerReportData[condition].avgBackliftDirectionHorizantal),
            consistancyBackliftHorizantal: Math.round(this.props.playerReportData[condition].consistancyBackliftHorizantal),
            consistancyBackliftDirectionalHorizantal: Math.round(this.props.playerReportData[condition].consistancyBackliftDirectionalHorizantal),
            consistancyBatfaceHorizantal: Math.round(this.props.playerReportData[condition].consistancyBatfaceHorizantal),
            speedData: localSpeedData,
            backliftDirectionData: localBackliftDirectionData,
            batFaceData: localBatFaceData,
            efficiencyData: localEfficiencyData,
            timeToImpactData: localTimeToImpactData,
            verticalBackliftData: localVerticalBackliftData,
            horizontalBackliftData: localHorizontalBackliftData,
            verticalDownswingData: localVerticalDownswingData,
            horizontalDownswingData: localHorizontalDownswingData,
            powerData: localPowerData
        })
    }

    handleChange(event, newValue) {
        this.setState({ tabValue: newValue })
        if (this.props.playerReportData.hasOwnProperty("lifetime")) {
            var currentTs = new Date().getTime()
            var fromTs = new Date().getTime()
            switch (newValue) {
                case 0:
                    this.showReport("10d")
                    fromTs = currentTs - (10 * 24 * 60 * 60 * 1000)
                    this.setState({
                        headerData: moment(currentTs).format("lll") + " - " + moment(fromTs).format("lll")
                    })
                    break;
                case 1:
                    this.showReport("30d")
                    fromTs = currentTs - (30 * 24 * 60 * 60 * 1000)
                    this.setState({
                        headerData: moment(currentTs).format("lll") + " - " + moment(fromTs).format("lll")
                    })
                    break;
                case 2:
                    this.showReport("3Mth")
                    fromTs = currentTs - (90 * 24 * 60 * 60 * 1000)
                    this.setState({
                        headerData: moment(currentTs).format("lll") + " - " + moment(fromTs).format("lll")
                    })
                    break;
                case 3:
                    this.showReport("1Yr")
                    fromTs = currentTs - (365 * 24 * 60 * 60 * 1000)
                    this.setState({
                        headerData: moment(currentTs).format("lll") + " - " + moment(fromTs).format("lll")
                    })
                    break;
                case 4:
                    this.showReport("lifetime")
                    this.setState({
                        headerData: 'Lifetime'
                    })
                    break;
                default:
                    this.showReport("lifetime")
                    this.setState({
                        headerData: 'Lifetime'
                    })
                    break;
            }
        }
    }

    getPercentage(value, total) {
        if (total > 0) {
            return Math.round(value * 100 / total)
        } else {
            return 0
        }
    }
    handleEvent(event, picker) {
        console.log(picker.startDate);
    }
    handleCallback(start, end, label) {
        this.setState({ tabValue: 5 })
        console.log("start : " + start + " end : " + end + " label : " + label);
        const sessionToken = this.props.authUser.sessionToken;
        const playerUid = this.props.playerInView.uid;
        const payload = {
            'sessionToken': sessionToken,
            'playerUid': playerUid,
            'startDateTs': moment(start).unix() * 1000,
            'endDateTs': moment(end).unix() * 1000
        }
        this.setState({
            headerData: moment(start).format("lll") + " - " + moment(end).format("lll")
        })
        this.props.getPlayerByTimeReport(payload)
    }

    render() {
        return (
            <div className="app-wrapper">
                <div className="report">
                    <div style={{ padding: '0px 0px 0px 26px' }} className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center ">
                        <h2 className="title mb-3 mb-sm-0">{<IntlMessages id="sidebar.dashboard.overview" />}</h2>
                        <div>
                            <Tabs
                                value={this.state.tabValue}
                                onChange={this.handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab style={{ minWidth: 10, textTransform: 'none', marginBottom: -20 }} label="Last 10 Days" />
                                <Tab style={{ minWidth: 10, textTransform: 'none', marginBottom: -20 }} label="Last 30 Days" />
                                <Tab style={{ minWidth: 10, textTransform: 'none', marginBottom: -20 }} label="Last 3 Months" />
                                <Tab style={{ minWidth: 10, textTransform: 'none', marginBottom: -20 }} label="Current Year" />
                                <Tab style={{ minWidth: 10, textTransform: 'none', marginBottom: -20 }} label="Lifetime" />
                                {/* <Tab style={{ minWidth: 0, textTransform: 'none', width: 0 }} label="" disabled /> */}
                                <DateRangePicker onEvent={this.handleEvent} onCallback={this.handleCallback}>
                                    <div className="mx-3" style={{ marginBottom: '-20px', paddingTop: '14px' }}><span className="pl-1"><DateRangeIcon /></span></div>
                                </DateRangePicker>
                            </Tabs>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card-header py-3 mb-4 text-center">

                                <h3 className="mb-0">{this.state.headerData}</h3>
                                {!this.props.playerReportLoader && !this.props.playerReportByTimeLoader && this.props.playerReportData !== null && (!this.props.playerReportData.hasOwnProperty("lifetime") || this.state.totalSessions === 0) ? (
                                    <h3 className="mb-0 text-danger pt-3">No Data Available</h3>

                                ) : ''}
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-3 col-sm-6 col-12">
                            <div className="card jr-card-intra shadow text-center">
                                <div className="card-header py-2 d-flex align-items-center">
                                    <h4 className="mb-0"><IntlMessages id="sidebar.totalSessionsPlayed" /></h4>
                                </div>

                                <div className="stack-order py-3 px-2" style={{ minHeight: '90px', display: 'flex', alignItems: 'center' }}>
                                    {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                        <Skeleton animation="wave" variant="rect" style={{ height: 50, width: '100%' }} />
                                    ) : (
                                            <h1 className="text-size-30" style={{ margin: 'auto' }}>{this.state.totalSessions}</h1>
                                        )}
                                </div>

                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                            <div className="card jr-card-intra shadow text-center">
                                <div className="card-header py-2 d-flex align-items-center">
                                    <h4 className="mb-0"><IntlMessages id="sidebar.totalSwings" /></h4>
                                </div>
                                <div className="stack-order px-2" style={{ minHeight: '90px' }}>
                                    <div className="p-0">
                                        {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="d-flex flex-row p-0 mb-3" style={{ height: 30 }} />
                                        ) : (
                                                <div>
                                                    <div className="d-flex flex-row p-0">
                                                        <p className="m-0">Played | {this.state.totalPlayed}</p>
                                                        <p className="ml-auto m-0">{this.getPercentage(this.state.totalPlayed, this.state.totalSwings)}%</p>
                                                    </div>
                                                    <Progress className="shadow-sm mb-3 my-1" style={{ height: 6 }} color={'#008CD5'} value={this.getPercentage(this.state.totalPlayed, this.state.totalSwings)} />
                                                </div>
                                            )}
                                        {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="d-flex flex-row p-0" style={{ height: 30 }} />
                                        ) : (
                                                <div>
                                                    <div className="d-flex flex-row">
                                                        <p className="m-0">Missed | {this.state.totalSwings - this.state.totalPlayed}</p>
                                                        <p className="ml-auto m-0">{(this.state.totalPlayed > 0) ? 100 - this.getPercentage(this.state.totalPlayed, this.state.totalSwings) : 0}%</p>
                                                    </div>
                                                    <Progress className="shadow-sm my-1" style={{ height: 6 }} color="warning" value={(this.state.totalPlayed > 0) ? 100 - this.getPercentage(this.state.totalPlayed, this.state.totalSwings) : 0} />
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                            <div className="card jr-card-intra shadow text-center">
                                <div className="card-header py-2 d-flex align-items-center">
                                    <h4 className="mb-0"><IntlMessages id="sidebar.totalTimePlayed" /></h4>
                                </div>
                                <div className="stack-order py-3 px-2" style={{ minHeight: '90px', display: 'flex', alignItems: 'center' }}>
                                    {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                        <Skeleton animation="wave" variant="rect" style={{ height: 50, width: '100%' }} />
                                    ) : (
                                            <div style={{ margin: 'auto' }}>
                                                <span className="text-size-30">{(this.state.totalDuration > 0) ? parseInt(this.state.totalDuration / 3600) : 0}</span><span className="h5">Hrs </span>
                                                <span className="text-size-30">{(this.state.totalDuration > 0) ? parseInt((this.state.totalDuration / 60) % 60) : 0}</span><span className="h5">Mins</span>
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                            <div className="card jr-card-intra shadow text-center">
                                <div className="card-header py-2 d-flex align-items-center">
                                    <h4 className="mb-0"><IntlMessages id="sidebar.shotType" /></h4>
                                </div>
                                <div className="stack-order py-1 px-2" style={{ minHeight: '90px', display: 'flex', alignItems: 'center' }}>
                                    {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                        <Skeleton animation="wave" variant="rect" style={{ height: 50, width: '100%' }} />
                                    ) : (
                                            <div className="row" style={{ margin: 'auto' }}>
                                                <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5 low-col-padding" style={{ margin: 'auto' }}>
                                                    <div className="pt-1">
                                                        <ResponsiveContainer width="100%">
                                                            <DoughnutChart verticalData={this.getPercentage(this.state.overallDefence, this.state.totalSwings)} horizontalData={(this.state.totalPlayed > 0) ? 100 - this.getPercentage(this.state.overallDefence, this.state.totalSwings) : 0} />
                                                        </ResponsiveContainer>
                                                    </div>
                                                </div>
                                                <div className="col-xl-7 col-lg-7 col-md-7 col-sm-6 col-7 low-col-padding">
                                                    <div className="media mt-3" style={{ textAlign: 'left' }}>
                                                        <i className="zmdi zmdi-check-square zmdi-hc-fw mr-2 text-success" />
                                                        <div className="media-body">
                                                            <h5 className="mb-0">Defence ({this.getPercentage(this.state.overallDefence, this.state.totalSwings)}%)</h5>
                                                        </div>
                                                    </div>
                                                    <div className="media mt-1" style={{ textAlign: 'left' }}>
                                                        <i className="zmdi zmdi-check-square zmdi-hc-fw mr-2 text-warning" />
                                                        <div className="media-body">
                                                            <h5 className="mb-0">Attack ({(this.state.totalPlayed > 0) ? 100 - this.getPercentage(this.state.overallDefence, this.state.totalSwings) : 0}%)</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-12">
                            <div className="card jr-card-intra shadow text-center">
                                <div className="card-header py-3 d-flex align-items-center">
                                    <h3 className="mb-0">Vertical Shots</h3>
                                    {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                        <Skeleton animation="wave" variant="rect" className="ml-auto" style={{ height: 30, width: 50 }} />
                                    ) : (
                                            <span className="badge badge-primary ml-auto">{this.state.totalVerticleSwings}</span>
                                        )}
                                </div>
                                <div className="stack-order py-3 px-2">
                                    <div className="row">
                                        <div className="col-lg-9 col-md-9 col-12">
                                            <div className="card-header py-2 d-flex align-items-center">
                                                <h4 className="mb-0">Average</h4>
                                            </div>
                                            <div className="card jr-card-intra shadow text-center" style={{ marginBottom: '15px' }}>
                                                <div className="row no-gutters">
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgEfficiencyVertical}</h1>
                                                                        <span className="h5">Efficiency</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgBatSpeedVertical}</h1>
                                                                        <span className="h5">Bat Speed</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgImpactSpeedVertical}</h1>
                                                                        <span className="h5">Impact Speed</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card jr-card-intra shadow text-center" style={{ marginBottom: '15px' }}>
                                                <div className="row no-gutters">
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgBackliftVertical}</h1>
                                                                        <span className="h5">Backlift</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgDownswingAngleVertical}</h1>
                                                                        <span className="h5">Downswing Angle</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgFollowThruAngleVertical}</h1>
                                                                        <span className="h5">Follow Through Angle</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card jr-card-intra shadow text-center">
                                                <div className="row no-gutters">
                                                    <div className="col-6">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgBatfaceVertical}</h1>
                                                                        <span className="h5">Bat Face</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgBackliftDirectionVertical}</h1>
                                                                        <span className="h5">Backlift Direction</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <div className="card-header py-2 d-flex align-items-center">
                                                <h4 className="mb-0 text-center">Consistancy</h4>
                                            </div>
                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="mb-2 report-consistancy-circular-progress-margin" style={{ height: 120 }} />
                                            ) : (
                                                    <div className="pb-2">
                                                        <div className="report-consistancy-circular-progress-margin">
                                                            <CircularProgressbarWithChildren value={this.state.consistancyBackliftVertical} maxValue={100} styles={buildStyles({
                                                                pathTransitionDuration: 0.5,
                                                                pathColor: '#5D00FF',
                                                                textColor: '#f88',
                                                                trailColor: '#d3baff',
                                                                backgroundColor: '#3e98c7',
                                                            })}>
                                                                <div style={{ fontSize: '16px' }}>
                                                                    {this.state.consistancyBackliftVertical} %
                                                                </div>
                                                            </CircularProgressbarWithChildren>
                                                        </div>
                                                        <div className="h5 text-center">Backlift</div>
                                                    </div>
                                                )}
                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="mb-2 report-consistancy-circular-progress-margin" style={{ height: 120 }} />
                                            ) : (
                                                    <div className="pb-2">
                                                        <div className="report-consistancy-circular-progress-margin">
                                                            <CircularProgressbarWithChildren value={this.state.consistancyBackliftDirectionalVertical} maxValue={100} styles={buildStyles({
                                                                pathTransitionDuration: 0.5,
                                                                pathColor: '#FFCC00',
                                                                textColor: '#f88',
                                                                trailColor: '#fceeb6',
                                                                backgroundColor: '#3e98c7',
                                                            })}>
                                                                <div style={{ fontSize: '16px' }}>
                                                                    {this.state.consistancyBackliftDirectionalVertical} %
                                                        </div>
                                                            </CircularProgressbarWithChildren>
                                                        </div>
                                                        <div className="h5 text-center">Backlift Direction</div>
                                                    </div>
                                                )}
                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="report-consistancy-circular-progress-margin" style={{ height: 120 }} />
                                            ) : (
                                                    <div>
                                                        <div className="report-consistancy-circular-progress-margin">
                                                            <CircularProgressbarWithChildren value={this.state.consistancyBatfaceVertical} maxValue={100} styles={buildStyles({
                                                                pathTransitionDuration: 0.5,
                                                                pathColor: '#0099FF',
                                                                textColor: '#f88',
                                                                trailColor: '#c3e4fa',
                                                                backgroundColor: '#3e98c7',
                                                            })}>
                                                                <div style={{ fontSize: '16px' }}>
                                                                    {this.state.consistancyBatfaceVertical} %
                                                        </div>
                                                            </CircularProgressbarWithChildren>
                                                        </div>
                                                        <div className="h5 text-center">Bat Face</div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-12">
                            <div className="card jr-card-intra shadow text-center">
                                <div className="card-header py-3 d-flex align-items-center">
                                    <h3 className="mb-0">Horizontal Shots</h3>
                                    {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                        <Skeleton animation="wave" variant="rect" className="ml-auto" style={{ height: 30, width: 50 }} />
                                    ) : (
                                            <span className="badge badge-primary ml-auto">{this.state.totalHorizantalSwings}</span>
                                        )}
                                </div>
                                <div className="stack-order py-3 px-2">
                                    <div className="row">
                                        <div className="col-lg-9 col-md-9 col-12">
                                            <div className="card-header py-2 d-flex align-items-center">
                                                <h4 className="mb-0">Average</h4>
                                            </div>
                                            <div className="card jr-card-intra shadow text-center" style={{ marginBottom: '15px' }}>
                                                <div className="row no-gutters">
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgEfficiencyHorizantal}</h1>
                                                                        <span className="h5">Efficiency</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgBatSpeedHorizantal}</h1>
                                                                        <span className="h5">Bat Speed</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgImpactSpeedHorizantal}</h1>
                                                                        <span className="h5">Impact Speed</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card jr-card-intra shadow text-center" style={{ marginBottom: '15px' }}>
                                                <div className="row no-gutters">
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgBackliftHorizantal}</h1>
                                                                        <span className="h5">Backlift</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgDownswingAngleHorizantal}</h1>
                                                                        <span className="h5">Downswing Angle</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgFollowThruAngleHorizantal}</h1>
                                                                        <span className="h5">Follow Through Angle</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card jr-card-intra shadow text-center">
                                                <div className="row no-gutters">
                                                    <div className="col-6">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgBatfaceHorizantal}</h1>
                                                                        <span className="h5">Bat Face</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="stack-order py-4 px-2">
                                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                                <Skeleton animation="wave" variant="rect" style={{ height: 70, width: '100%' }} />
                                                            ) : (
                                                                    <div>
                                                                        <h1 className="chart-f20">{this.state.avgBackliftDirectionHorizantal}</h1>
                                                                        <span className="h5">Backlift Direction</span>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <div className="card-header py-2 d-flex align-items-center">
                                                <h4 className="mb-0 text-center">Consistancy</h4>
                                            </div>
                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="mb-2 report-consistancy-circular-progress-margin" style={{ height: 120 }} />
                                            ) : (
                                                    <div className="pb-2">
                                                        <div className="report-consistancy-circular-progress-margin">
                                                            <CircularProgressbarWithChildren value={this.state.consistancyBackliftHorizantal} maxValue={100} styles={buildStyles({
                                                                pathTransitionDuration: 0.5,
                                                                pathColor: '#5D00FF',
                                                                textColor: '#f88',
                                                                trailColor: '#d3baff',
                                                                backgroundColor: '#3e98c7',
                                                            })}>
                                                                <div style={{ fontSize: '16px' }}>
                                                                    {this.state.consistancyBackliftHorizantal} %
                                                        </div>
                                                            </CircularProgressbarWithChildren>
                                                        </div>
                                                        <div className="h5 text-center">Backlift</div>
                                                    </div>
                                                )}
                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="mb-2 report-consistancy-circular-progress-margin" style={{ height: 120 }} />
                                            ) : (
                                                    <div className="pb-2">
                                                        <div className="report-consistancy-circular-progress-margin">
                                                            <CircularProgressbarWithChildren value={this.state.consistancyBackliftDirectionalHorizantal} maxValue={100} styles={buildStyles({
                                                                pathTransitionDuration: 0.5,
                                                                pathColor: '#FFCC00',
                                                                textColor: '#f88',
                                                                trailColor: '#fceeb6',
                                                                backgroundColor: '#3e98c7',
                                                            })}>
                                                                <div style={{ fontSize: '16px' }}>
                                                                    {this.state.consistancyBackliftDirectionalHorizantal} %
                                                        </div>
                                                            </CircularProgressbarWithChildren>
                                                        </div>
                                                        <div className="h5 text-center">Backlift Direction</div>
                                                    </div>
                                                )}
                                            {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                                <Skeleton animation="wave" variant="rect" className="report-consistancy-circular-progress-margin" style={{ height: 120 }} />
                                            ) : (
                                                    <div>
                                                        <div className="report-consistancy-circular-progress-margin">
                                                            <CircularProgressbarWithChildren value={this.state.consistancyBatfaceHorizantal} maxValue={100} styles={buildStyles({
                                                                pathTransitionDuration: 0.5,
                                                                pathColor: '#0099FF',
                                                                textColor: '#f88',
                                                                trailColor: '#c3e4fa',
                                                                backgroundColor: '#3e98c7',
                                                            })}>
                                                                <div style={{ fontSize: '16px' }}>
                                                                    {this.state.consistancyBatfaceHorizantal} %
                                                        </div>
                                                            </CircularProgressbarWithChildren>
                                                        </div>
                                                        <div className="h5 text-center">Bat Face</div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <hr className="hr-text-center pb-2" data-content="Progress" />
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-6 col-12">
                            <CardBox heading="Max Bat Speed Vs Bat Speed at Impact">
                                {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                ) : (
                                        <StanceBeamDoubleBarChart chartData={this.state.speedData} firstBarColor="#ffc658" secondBarColor="#6399A3" />
                                    )}
                            </CardBox>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                            <CardBox heading="Backlift Direction Angle">
                                {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                ) : (
                                        <StanceBeamBarChart chartData={this.state.backliftDirectionData} barColor="#ffc658" />
                                    )}
                            </CardBox>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                            <CardBox heading="Bat Face Angle">
                                {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                ) : (
                                        <StanceBeamBarChart chartData={this.state.batFaceData} barColor="#6399A3" />
                                    )}
                            </CardBox>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                            <CardBox heading="Efficiency">
                                {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                ) : (
                                        <StanceBeamBarChart chartData={this.state.efficiencyData} barColor="#ffc658" />
                                    )}
                            </CardBox>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                            <CardBox heading="Time to Impact">
                                {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                ) : (
                                        <StanceBeamBarChart chartData={this.state.timeToImpactData} barColor="#6399A3" />
                                    )}
                            </CardBox>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                            <CardBox heading="Backlift Angle">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                        {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                        ) : (
                                                <div>
                                                    <div style={{ marginTop: '-10px' }} className="text-center">Vertical Bat Swings</div>
                                                    <StanceBeamBarChart chartData={this.state.verticalBackliftData} barColor="#ffc658" />
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                        {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                        ) : (
                                                <div>
                                                    <div style={{ marginTop: '-10px' }} className="text-center">Horizontal Bat Swings</div>
                                                    <StanceBeamBarChart chartData={this.state.horizontalBackliftData} barColor="#6399A3" />
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </CardBox>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                            <CardBox heading="Downswing Angle">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                        {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                        ) : (
                                                <div>
                                                    <div style={{ marginTop: '-10px' }} className="text-center">Vertical Bat Swings</div>
                                                    <StanceBeamBarChart chartData={this.state.verticalDownswingData} barColor="#ffc658" />
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                        {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                        ) : (
                                                <div>
                                                    <div style={{ marginTop: '-10px' }} className="text-center">Horizontal Bat Swings</div>
                                                    <StanceBeamBarChart chartData={this.state.horizontalDownswingData} barColor="#6399A3" />
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </CardBox>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                            <CardBox heading="Power">
                                {this.props.playerReportLoader || this.props.playerReportByTimeLoader || this.props.playerReportData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                ) : (
                                        <StanceBeamBarChart chartData={this.state.powerData} barColor="#ffc658" />
                                    )}
                            </CardBox>
                        </div>
                    </div>
                </div>
            </div>

        );
    }

}

const mapStateToProps = ({ auth, player, playerReport }) => {
    const { authUser } = auth;
    const { playerInView } = player;
    const { playerUid, playerReportData, playerReportLoader, playerReportError, playerReportByTimeLoader, playerReportByTimeError } = playerReport;
    return { authUser, playerInView, playerUid, playerReportData, playerReportLoader, playerReportError, playerReportByTimeLoader, playerReportByTimeError }
};
export default withRouter(connect(mapStateToProps, {
    getPlayerReport,
    getPlayerByTimeReport
})(Report));